import currency from "currency.js";

const options = {
  symbol: "€",
  increment: .01
};

export default {
  install(Vue) {
    Vue.prototype.$currency = (v, precision = 5) =>
      currency(v, Object.assign({ precision }, options));
  },
};
